module.exports = __webpack_public_path__ + "4bbced0aa21ecf1da463cbadcfe7457c.png";